import settingComponent from './settings.component';
import settingService from './settings.service';
import {getHumanReadableAccountById} from '../companies/getHumanReadableAccountById.filter';

export const settingsModule = angular
    .module('settings', [])
    .component('settings', settingComponent)
    .service('$settings', settingService)
    .filter('getHumanReadableAccountById', getHumanReadableAccountById);



/** WEBPACK FOOTER **
 ** ./frontend/components/admin/settings/settings.js
 **/